const getViewType = () => {
  const locationPath = window.location.pathname;
  const result = locationPath.replace(/^\/host\//, '');

  return result;
};

export default getViewType;
